import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/hamilelikte-botoks-bilimsel-gercekler-riskler-ve-uzman-gorusu/page.tsx");
